<template>
  <div class="wind">
    <van-icon v-if="$route.query.isBanner == 0 && $route.query.isApp == 1" id="backIcon" @click="$router.back()" :name="isDirection ? 'arrow' : 'arrow-left'" />
    <div>
      <b>{{ $t("300148") }}</b>
      <div class="main" v-if="winPeople.length > 0">
        <!--账号   奖励-->
        <p>
          <span>{{ $t("300418") }}</span>
          <span>{{ $t("300085") }}</span
          >
        </p>
        <div class="winuser">
          <div>
            <p v-for="(item, index) in winPeople" :key="index">
              <span>{{ index+1 >= 10 ? index+1 : '0'+(index+1) }}</span>
              <span>{{ item.account }}</span>
            </p>
          </div>
        </div>
      </div>
      <van-empty class="custom-image" :description="$t('300108')" v-else>
        <svg slot="image" class="icon" aria-hidden="true">
          <use xlink:href="#icon-jilu1"></use>
        </svg>
      </van-empty>
    </div>
  </div>
</template>

<script>
import { userwind, signConfigApi } from "../api/resource";
import { Empty,Icon } from "vant";
export default {
  data() {
    return {
      winPeople: [],
      price: 0
    };
  },
  components: {
    vanEmpty: Empty,
    vanIcon:Icon
  },

  created() {
    userwind().then(res => {
      this.winPeople = res.data;
    });
    signConfigApi().then(res => {
      this.price = res.data.rewardConfigList[2].amount;
    });
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/css/variableName";
@import "../style/mixin";
#backIcon{
  margin: torem(16) torem(0) torem(0);
  font-size: torem(18);
}
.wind {
  padding: 0 torem(25);
  overflow-y: scroll;
  min-height: 100vh;
  background: #fff;
  > p {
    font-size: torem(14);
  }
  b {
    font-size: torem(16);
    padding: torem(0) 0 torem(20);
    line-height: torem(60);
  }
}
.main {
  > p {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #999;
  }
}
.icon {
  width: torem(56);
  height: torem(56);
}
.winuser {
  p {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
.custom-image {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  > p {
    text-align: center;
    margin-right: 20px;
  }
}
.custom-image {
  padding-top: torem(60) !important;
  /deep/ .van-empty__image {
    width: torem(56);
    height: torem(56);
    svg {
      width: torem(56);
      height: torem(56);
    }
  }
  /deep/ .van-empty__description {
    font-size: torem(14);
  }
}
.wind {
  p {
    text-align: center;
    font-size: torem(14);
  }
}
.main {
  p {
    height: torem(42);
    line-height: torem(42);
  }
}
</style>



// WEBPACK FOOTER //
// src/view/winprize.vue